export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/b3dc542ec1b5794376b3d1da54a4e35b.svg";